module.exports = __webpack_public_path__ + "img/addRemarkWhite.50cdac7e.svg";